import { Game } from "../../../";
import blocksFromNumberArray from "./blocksFromNumberArray";

const _ = null;

export default {
  blocks: blocksFromNumberArray([
    [0, _, _, _, _, _, 0, _, _, 3, 3, _, _, _, _],
    [_, _, 1, _, 1, _, 3, _, _, _, _, _, 4, _, 0],
    [0, _, _, 2, _, _, 4, 5, _, 7, 6, _, 6, _, _],
    [_, _, _, 1, _, _, _, 5, 5, _, 6, _, 6, _, _],
    [2, 2, 3, _, _, 2, 3, _, _, _, _, _, _, _, 4],
    [_, _, 3, 2, _, _, _, 5, 4, 5, 4, _, _, _, 4],
    [_, 3, 4, _, 3, 3, 3, _, 5, _, 5, _, 6, _, _],
    [_, _, 2, _, 2, 3, _, 4, _, 3, 4, 7, 8, _, 5],
    [0, _, _, _, 4, _, _, 4, _, _, 3, _, _, 9, _],
    [_, _, 4, _, 4, 4, _, _, 3, 4, _, 4, 5, _, 5],
    [_, _, _, 6, _, 6, _, _, _, _, 3, 2, 3, 5, _],
    [3, _, 5, 5, 3, _, _, 3, 3, 3, _, _, _, _, _],
    [3, _, _, _, _, _, 4, 5, _, 4, _, 0, 0, 2, _],
    [_, _, 5, _, 3, _, _, _, 7, 5, _, _, _, _, _],
    [_, 2, _, 2, _, 3, 5, 6, _, _, 4, _, _, 4, _],
  ]),
  height: 15,
  name: "caffe",
  width: 15,
} as Game;
